import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpStatusCode } from '../enums/http-status-code.enum';
import { AuthService } from '../services/auth.service';
import { DialogsService } from '../services/dialog.service';
import { DialogState } from '../models/dialog-state';
import { Router } from '@angular/router';
import { AppUrls } from '../app-urls';

/** Содержит логику по обработке ответов от сервера, содержащих ошибки. */
@Injectable()
export class HttpErrorHandlingInterceptor implements HttpInterceptor {
  private readonly window: IWindow = <any> (window);

  constructor(
    private auth: AuthService,
    private _router: Router,
    private _dialogService: DialogsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          case HttpStatusCode.Unauthorized:
            try {
              this._dialogService.showErrorWithHtmlContent({
                headerText: 'Ваш сеанс работы завершен',
                content: `
                  <div style="text-align: center;width: 600px;">
                      Мы завершили сеанс работы из-за продолжительного бездействия, чтобы вашим личным
                      кабинетом не воспользовались посторонние.
                      <br>
                      <br>
                      Для продолжения нажмите "ОК" и войдите в свой личный кабинет.
                  </div>
              `,
                closeButtonLabel: 'ОК',
                closable: false,
                onHide: (e) => {
                  this.auth.redirectToAuthPage();
                },
              } as DialogState);
            } catch (err) {
              this.auth.redirectToAuthPage();
            }
            return [];
          case HttpStatusCode.Forbidden:
            this._router.navigateByUrl(AppUrls.errorUrls.forbiddenPage);
            return [];
          default:
            return throwError(error);
        }
      })
    );
  }
}
